import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Tooltip
} from '@mui/material';
import { DirectionsCar, AdminPanelSettings } from '@mui/icons-material';
import AdminPanel from './AdminPanel';

interface AppHeaderProps {
  onUploadSuccess: () => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({ onUploadSuccess }) => {
  const [adminOpen, setAdminOpen] = useState(false);

  return (
    <>
      <AppBar 
        position="static" 
        sx={{ 
          background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 50%, #64b5f6 100%)',
          boxShadow: '0 4px 20px rgba(25, 118, 210, 0.3)'
        }}
      >
        <Toolbar sx={{ py: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 48,
                height: 48,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.2)',
                mr: 2,
                backdropFilter: 'blur(10px)'
              }}
            >
              <DirectionsCar sx={{ fontSize: 28, color: 'white' }} />
            </Box>
            <Box>
              <Typography variant="h5" component="h1" sx={{ 
                fontWeight: 'bold',
                color: 'white',
                textShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}>
                Car Import Tax Calculator
              </Typography>
              <Typography variant="body2" sx={{ 
                color: 'rgba(255, 255, 255, 0.8)',
                fontWeight: 300
              }}>
                Finnish Vehicle Import Tax Database
              </Typography>
            </Box>
          </Box>
          
          <Tooltip title="Admin Panel">
            <IconButton
              onClick={() => setAdminOpen(true)}
              sx={{ 
                color: 'white',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  transform: 'scale(1.05)'
                },
                transition: 'all 0.2s ease-in-out'
              }}
            >
              <AdminPanelSettings />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>

      <AdminPanel
        open={adminOpen}
        onClose={() => setAdminOpen(false)}
        onUploadSuccess={onUploadSuccess}
      />
    </>
  );
};

export default AppHeader;
